import { module } from 'angular';
import mailFormHeaderComponent from './mail-form-header/mail-form-header.component';
import mailFormInputComponent from './mail-form-input/mail-form-input.component';

export default module('app')
	.component('mailFormHeader', mailFormHeaderComponent)
	.component('mailFormInput', mailFormInputComponent)
	.name;
